import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export const useMarkReplied = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (engId: string) => api.inbox.markReplied(engId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["inbox"] }),
  });
};
